import {Col, Menu, Modal, Row, Skeleton, Tag, Tooltip} from 'antd';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import AppScrollbar from 'src/domain/core/AppScrollbar';
import IntlMessages from 'src/domain/utility/IntlMessages';
import {formatDateWithSecondsTime} from 'src/shared/constants/AppConst';
import {ordersService} from 'src/shared/services/orders';
import {OrderDetailsDto} from 'src/shared/services/orders/dto/order-details-dto';
import {
  TrackDetailsDto,
  TrackingResultsValueDto,
} from 'src/shared/services/orders/dto/track-details-dto';
import MainUtils from 'src/shared/utils/main';

interface TrackShipmentModalProps {
  orderDetails?: OrderDetailsDto;
  visible: boolean;
  onCancel: () => void;
}
const TrackShipmentModal: React.FC<TrackShipmentModalProps> = (props) => {
  const {orderDetails, visible, onCancel} = props;

  const [isTrackShipmentLoading, setIsTrackShipmentLoading] = useState(false);

  const [trackDetailsInfo, setTrackDetailsInfo] = useState<TrackDetailsDto>();

  const [trackDetailsById, setTrackDetailsById] = useState(0);

  const convertFromStringToDate = (item: string) => {
    const start = item.indexOf('(') + 1;
    const end = item.indexOf('+');
    const value = item.substring(start, end);
    return {
      date: new Date(parseInt(value)),
      dateNumber: parseInt(value),
    };
  };

  useEffect(() => {
    if (visible) {
      (async () => {
        try {
          setIsTrackShipmentLoading(true);
          const trackDetails = await ordersService.track(
            orderDetails?.Id ?? '',
          );
          trackDetails?.TrackingResults[0].Value?.sort((a: any, b: any) => {
            return (
              convertFromStringToDate(b.UpdateDateTime).dateNumber -
              convertFromStringToDate(a.UpdateDateTime).dateNumber
            );
          }).map((item: TrackingResultsValueDto, index: number) => {
            item.id = index;
            return item;
          });
          setTrackDetailsInfo(trackDetails);
        } catch (error) {
          console.error(error);
        } finally {
          setIsTrackShipmentLoading(false);
        }
      })();
    }
  }, [visible, orderDetails]);

  const notFound = () => {
    return <Tag className='ant-tag-disable-pointer'></Tag>;
  };

  const renderRrackDetailsInfo = (item: TrackingResultsValueDto) => {
    return (
      <>
        <Row>
          <Col span={24}>
            <table style={{width: '100%'}}>
              <tbody>
                <tr>
                  <td>
                    <strong>
                      <IntlMessages id='orders.orderDetails.orderItems.trackShipment.chargeableWeight' />
                    </strong>
                  </td>
                  <td className='details-col-style'>
                    <label>
                      {!MainUtils.isEmptyValue(item.ChargeableWeight)
                        ? item.ChargeableWeight
                        : notFound()}
                    </label>
                  </td>
                </tr>
                <tr className='details-row-style'>
                  <td>
                    <strong>
                      <IntlMessages id='orders.orderDetails.orderItems.trackShipment.comments' />
                    </strong>
                  </td>
                  <td className='details-col-style'>
                    <label>
                      {!MainUtils.isEmptyValue(item.Comments) ? (
                        item.Comments?.length < 50 ? (
                          item.Comments
                        ) : (
                          <Tooltip title={item.Comments}>
                            <span>
                              {`...${
                                item.Comments?.substring(
                                  item.Comments?.length - 50,
                                ) ?? ''
                              }`}
                            </span>
                          </Tooltip>
                        )
                      ) : (
                        notFound()
                      )}
                    </label>
                  </td>
                </tr>
                <tr className='details-row-style'>
                  <td>
                    <strong>
                      <IntlMessages id='orders.orderDetails.orderItems.trackShipment.grossWeight' />
                    </strong>
                  </td>
                  <td className='details-col-style'>
                    <label>
                      {!MainUtils.isEmptyValue(item.GrossWeight)
                        ? item.GrossWeight
                        : notFound()}
                    </label>
                  </td>
                </tr>
                <tr className='details-row-style'>
                  <td>
                    <strong>
                      <IntlMessages id='orders.orderDetails.orderItems.trackShipment.updateCode' />
                    </strong>
                  </td>
                  <td className='details-col-style'>
                    <label>
                      {!MainUtils.isEmptyValue(item.UpdateCode)
                        ? item.UpdateCode
                        : notFound()}
                    </label>
                  </td>
                </tr>
                <tr className='details-row-style'>
                  <td>
                    <strong>
                      <IntlMessages id='orders.orderDetails.orderItems.trackShipment.problemCode' />
                    </strong>
                  </td>
                  <td className='details-col-style'>
                    <label>
                      {!MainUtils.isEmptyValue(item.ProblemCode)
                        ? item.ProblemCode
                        : notFound()}
                    </label>
                  </td>
                </tr>
                <tr className='details-row-style'>
                  <td>
                    <strong>
                      <IntlMessages id='orders.orderDetails.orderItems.trackShipment.updateDateTime' />
                    </strong>
                  </td>
                  <td className='details-col-style'>
                    <label>
                      {!MainUtils.isEmptyValue(item.UpdateDateTime)
                        ? moment(
                            convertFromStringToDate(item.UpdateDateTime).date,
                          ).format(formatDateWithSecondsTime)
                        : notFound()}
                    </label>
                  </td>
                </tr>
                <tr className='details-row-style'>
                  <td>
                    <strong>
                      <IntlMessages id='orders.orderDetails.orderItems.trackShipment.updateDescription' />
                    </strong>
                  </td>
                  <td className='details-col-style'>
                    <label>
                      {!MainUtils.isEmptyValue(item.UpdateDescription)
                        ? item.UpdateDescription
                        : notFound()}
                    </label>
                  </td>
                </tr>
                <tr className='details-row-style'>
                  <td>
                    <strong>
                      <IntlMessages id='orders.orderDetails.orderItems.trackShipment.updateLocation' />
                    </strong>
                  </td>
                  <td className='details-col-style'>
                    <label>
                      {!MainUtils.isEmptyValue(item.UpdateLocation)
                        ? item.UpdateLocation
                        : notFound()}
                    </label>
                  </td>
                </tr>
                <tr className='details-row-style'>
                  <td>
                    <strong>
                      <IntlMessages id='orders.orderDetails.orderItems.trackShipment.waybillNumber' />
                    </strong>
                  </td>
                  <td className='details-col-style'>
                    <label>
                      {!MainUtils.isEmptyValue(item.WaybillNumber)
                        ? item.WaybillNumber
                        : notFound()}
                    </label>
                  </td>
                </tr>
                <tr className='details-row-style'>
                  <td>
                    <strong>
                      <IntlMessages id='orders.orderDetails.orderItems.trackShipment.weightUnit' />
                    </strong>
                  </td>
                  <td className='details-col-style'>
                    <label>
                      {!MainUtils.isEmptyValue(item.WeightUnit)
                        ? item.WeightUnit
                        : notFound()}
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
      </>
    );
  };

  const items: any[] =
    trackDetailsInfo?.TrackingResults &&
    trackDetailsInfo?.TrackingResults?.length > 0
      ? trackDetailsInfo?.TrackingResults[0]?.Value?.map((item, index) => {
          return {
            key: index,
            label: item.UpdateDescription,
          };
        })
      : [];

  return (
    <Modal
      className='add-product-modal'
      width={'800px'}
      onCancel={() => onCancel()}
      centered
      open={visible}
      title={
        <>
          <div className='text-title'>
            <IntlMessages id='orders.orderDetails.orderItems.trackShipment' />
          </div>
        </>
      }
      footer={false}>
      <Skeleton active loading={isTrackShipmentLoading}>
        <Row gutter={[20, 30]}>
          <Col span={8} className='max-height-500'>
            <AppScrollbar scrollToTop={false}>
              <Menu
                mode='vertical'
                items={items}
                selectedKeys={[`${trackDetailsById}`]}
                onClick={(item) => setTrackDetailsById(parseInt(item.key))}
              />
            </AppScrollbar>
          </Col>
          <Col span={16} className='max-height-500'>
            <AppScrollbar scrollToTop={false}>
              {
                <Row gutter={[0, 30]} className='fullContent'>
                  {trackDetailsInfo?.TrackingResults &&
                  trackDetailsInfo?.TrackingResults?.length > 0
                    ? trackDetailsInfo?.TrackingResults[0]?.Value?.filter(
                        (item) => item.id === trackDetailsById,
                      ).map((item) => {
                        return (
                          <Col span={24}>{renderRrackDetailsInfo(item)}</Col>
                        );
                      })
                    : null}
                </Row>
              }
            </AppScrollbar>
          </Col>
        </Row>
      </Skeleton>
    </Modal>
  );
};

export default TrackShipmentModal;
